import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["accept", "disabled"]
const _hoisted_3 = { class: "upload-state" }
const _hoisted_4 = {
  key: 0,
  class: "image-preview__image checkerboard"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "image-preview__placeholder"
}
const _hoisted_7 = { class: "upload-action" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "selected-image-buttons"
}

import { imageUploadApi } from '../services/webAssistantImageUpload';
import Toast from '@/shared/services/toast';
import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WebAssistantImageUpload',
  props: {
  accept: {
    type: String,
  },
  previewWidth: {
    type: Number,
  },
  previewHeight: {
    type: Number,
  },
  image: {
    type: String,
  },
  disabled: {
    type: Boolean,
  },
},
  emits: ["selected", "uploaded", "cleared"],
  setup(__props, { emit: __emit }) {

const props = __props;

const imageUploaded = ref(false);
const imageUrl = ref('');
const uploading = ref(false);

let inputElement: HTMLInputElement;

watch(
  () => props.image,
  (value) => {
    if (value) {
      imageUploaded.value = true;
      imageUrl.value = value;
    }
  },
  { immediate: true },
);

const emit = __emit;

function emitSelected() {
  emit('selected');
}

function emitUploaded(url: string) {
  emit('uploaded', url);
}

function emitCleared() {
  emit('cleared');
}

function imageSelected(e: Event) {
  if (props.disabled) {
    return;
  }

  inputElement = e.target as HTMLInputElement;
  if (!inputElement.files || inputElement.files.length === 0) {
    return;
  }

  const selectedFile = inputElement.files[0];
  if (!isValidFileType(selectedFile.type)) {
    Toast.showError(`Invalid file type - accepted types are .png, .jpg or .jpeg`);
    inputElement.value = '';
    return;
  }

  emitSelected();

  uploading.value = true;

  imageUploadApi
    .upload(selectedFile)
    .then((response) => {
      imageUploaded.value = true;
      imageUrl.value = response.url;
      emitUploaded(response.url);
      Toast.showSuccess('Image uploaded successfully');
    })
    .catch((err) => {
      // clear the file from the input
      // fixes issue where nothing happens if the
      // user goes to select the same image again
      inputElement.value = '';
      Toast.showError(err.message);
      emitCleared();
    })
    .finally(() => {
      uploading.value = false;
    });
}

function clearImage() {
  imageUrl.value = '';
  if (inputElement) {
    inputElement.value = '';
  }
  imageUploaded.value = false;
  emitCleared();
}

function isValidFileType(type: string) {
  return type === 'image/png' || type === 'image/jpeg';
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "file",
      id: "image-input",
      class: "image-input",
      accept: __props.accept,
      disabled: __props.disabled,
      onChange: imageSelected
    }, null, 40, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "image-preview",
        style: _normalizeStyle({ width: __props.previewWidth + 'px', height: __props.previewHeight + 'px' })
      }, [
        (imageUploaded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", { src: imageUrl.value }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        (!imageUploaded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.previewWidth) + "px x " + _toDisplayString(__props.previewHeight) + "px", 1))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!imageUploaded.value)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: "image-input",
            class: _normalizeClass(["button is-primary", { 'is-loading': uploading.value }]),
            disabled: __props.disabled
          }, " Choose file... ", 10, _hoisted_8))
        : _createCommentVNode("", true),
      (imageUploaded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_n_button, {
              variant: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (clearImage()))
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Clear", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})